import React from 'react';
import QuestionChoiceSkeleton from './QuestionChoiceSkeleton';

const QuestionLoadingSkeleton = () => (
  <div className=''>
    <div className="text-gray-600 w-[25%] h-6 bg-gray-400 animate-pulse"></div>
    <div className="mt-3 text-gray-600 w-[80%] h-8 bg-gray-400 animate-pulse"></div>
    <div className="mt-3 text-gray-600 w-[100%] h-6 bg-gray-400 animate-pulse"></div>
    <div className="mt-5 font-bold space-y-2">
      {Array.from({ length: 5 }).map((_, index) => (
        <QuestionChoiceSkeleton key={index} />
      ))}
    </div>
  </div>
);

export default QuestionLoadingSkeleton;